<template>
  <div>
    <el-button type="primary" @click="xinzengchanpin">新增产品</el-button>
    <el-dialog title="新增产品" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="产品名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xinzengzhengshi">确 定</el-button>
      </span>
    </el-dialog>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="createTime" label="日期" width="280px"></el-table-column>
      <el-table-column prop="name" label="产品名称"></el-table-column>
      <el-table-column label="操作" width="280px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="bianji(scope.$index, scope.row)">模块</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, tableData)">删除</el-button>
          <el-dialog title="编辑产品" :visible.sync="dialochanpin" width="50%">
            <el-form :model="form" label-width="80px">
              <el-form-item label="日期">
                <el-input v-model="form.createTime"></el-input>
              </el-form-item>
              <el-form-item label="产品名称">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialochanpin = false">取 消</el-button>
              <el-button type="primary" @click="bianjichanpin(form)">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="添加模块" :visible.sync="dialogmokuai" width="50%" append-to-body>
            <el-form :model="product" label-width="80px">
              <el-form-item label="模块名称">
                <el-input v-model="product.name"></el-input>
              </el-form-item>
              <el-form-item label="模块id">
                <el-input v-model="product.Id"></el-input>
              </el-form-item>
              <el-form-item label="脚本">
                <el-input v-model="product.script"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogmokuai = false">取 消</el-button>
              <el-button type="primary" @click="bianjimokuai(product)">确 定</el-button>
            </span>
            <div class="box">
              <input
                type="file"
                name="file-1[]"
                id="file-1"
                @input="inputfunc"
                class="inputfile inputfile-1"
                data-multiple-caption="{count} files selected"
                multiple
              />
              <label for="file-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                  <path
                    d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
                  />
                </svg>
                <span>点击选择文件&hellip;</span>
              </label>
            </div>
            <el-button type="primary" @click="piliangshangchuan(form)">批量上传</el-button>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        createTime: "",
        name: "",
      },
      product: {
        name: "",
        script: "",
      },
      dialogVisible: false,
      dialogmokuai: false,
      dialochanpin: false,
      tableData: [],
    };
  },
  mounted() {
    this.findproduct();
  },
  methods: {
    zimusort(propertyName) {
      return function (object1, object2) {
        var value1 = object1[propertyName];
        var value2 = object2[propertyName];
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    findproduct() {
      this.tableData = [];
      this.$http
        .post(this.$getaxiosurl("/enc/product/getAllProduct"))
        .then((res) => {
          if (res.data.code == "00100") {
            for (var i = 0; i < res.data.data.length; i++) {
              this.tableData.push(res.data.data[i]);
            }
            this.tableData.sort(this.zimusort("moduleName"));
          } else {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
    xinzengchanpin() {
      this.form = {};
      this.dialogVisible = true;
    },
    bianjimokuai(product) {
      let formData = new FormData();
      formData.append("productId", product.id);
      formData.append("moduleField", product.Id);
      formData.append("moduleName", product.name);
      formData.append("content", product.script);
      this.$http
        .post(this.$getaxiosurl("/enc/product/addModule"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "success",
            });
            this.dialogmokuai = false;
            this.tableData = [];
            this.product = {};
            this.findproduct();
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    xinzengzhengshi() {
      let formData = new FormData();
      formData.append("name", this.form.name);
      this.$http
        .post(this.$getaxiosurl("/enc/product/addFormalProduct"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.tableData = [];
            this.form = {};
            this.findproduct();
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    bianji(index, row) {
      this.dialogmokuai = true;
      this.product.id = row.id;
      this.form.id = row.id;
    },
    handleEdit(index, row) {
      this.dialochanpin = true;
      Object.assign(this.form, row);
      let formData = new FormData();
      formData.append("productId", row.id);
      this.$http
        .post(this.$getaxiosurl("/enc/product/getModuleByProductId"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    bianjichanpin(row) {
      let formData = new FormData();
      formData.append("id", row.id);
      formData.append("name", row.name);
      this.$http
        .post(this.$getaxiosurl("/enc/product/editFormalProduct"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "success",
            });
            this.tableData = [];
            this.dialochanpin = false;
            this.form = {};
            this.findproduct();
          } else {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    piliangshangchuan(row) {
      var fileInput = document.getElementById("file-1");
      let formData = new FormData();
      formData.append("productId", row.id);
      formData.append("moduleFile", fileInput.files[0]);
      this.$http
        .post(this.$getaxiosurl("/enc/product/batchAddModule"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "提交成功",
              type: "success",
            });
          } else {
            return this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    handleDelete(index, row) {
      row.splice(index, 1);
    },
    inputfunc() {
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();
          if (fileName) label.querySelector("span").innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },
  },
};
</script>
<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.box {
  line-height: 20px !important;
}
.grid-a-content-a-Width {
  border-radius: 4px;
  width: 100%;
}
.el-checkbox {
  color: #000000;
  margin: 40px;
}
h3 {
  text-align: center;
}
.el-input {
  padding-bottom: 1px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.js .inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  max-width: 80%;
  font-size: 1.25rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.no-js .inputfile + label {
  display: none;
}
.inputfile:focus + label,
.inputfile.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}
.inputfile-1 + label {
  color: #f1e5e6;
  background-color: #409eff;
}
.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
  background-color: #67c23a;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 160px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
